export default __webpack_public_path__ + "static/media/fullTest.5695650f.svg";